module.exports = __webpack_public_path__ + "img/logo-en.c724543b.png";